import { LoaderCircle } from '@skytech/ui'
import { Button } from '@skytech/ui/Button'
import { Container } from '@skytech/ui/Container'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import CheckIcon from 'mdi-react/CheckIcon'
import CloseIcon from 'mdi-react/CloseIcon'
import { useParams } from 'react-router-dom'

import { Translation } from '@/app/translations/Translation'
import injuryReportsResources from '@/modules/applications/injury-reports/resources'

import { INJURY_REPORT_STATUS_IDS } from './constants'
import InjuryReport from './InjuryReport'
import queries from './queries'

import './InjuryReportPage.styles.scss'

const InjuryReportPage = () => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  const {
    data: injuryReport,
    isLoading,
    refetch: updateInjuryReport,
  } = useQuery(queries.injuryReport(Number(id)), () => injuryReportsResources.get(Number(id)))

  const setStatusMutation = useMutation(
    (statusId: number) =>
      injuryReportsResources.setStatus({ injuryReportId: Number(id), statusId }),
    {
      onSuccess() {
        updateInjuryReport()
        // todo: change when the rq updateOnMount is on again
        queryClient.invalidateQueries(queries.injuryReports(), { refetchType: 'all' })
      },
    }
  )

  if (isLoading) {
    return (
      <Container className="injury-report">
        <Container.Header>
          <Translation id="Damage Report" /> #{id}
        </Container.Header>

        <LoaderCircle />
      </Container>
    )
  }

  if (!injuryReport) return null

  const { status, statusId } = injuryReport

  return (
    <Container className="injury-report">
      <Container.Header>
        <Translation id="Damage Report" /> #{id}
      </Container.Header>

      <>
        <h3>
          <Translation id={`injury_report_status/${status}`} />
        </h3>

        {statusId === INJURY_REPORT_STATUS_IDS.PENDING_MANAGER && (
          <div className="options">
            <Button
              className="ml-0"
              variant="primary"
              Icon={<CheckIcon />}
              isLoading={
                setStatusMutation.isLoading &&
                setStatusMutation.variables === INJURY_REPORT_STATUS_IDS.APPROVED_MANAGER
              }
              onClick={() => setStatusMutation.mutate(INJURY_REPORT_STATUS_IDS.APPROVED_MANAGER)}
            >
              <Translation id="Approve" />
            </Button>

            <Button
              className="ml-0"
              Icon={<CloseIcon />}
              isLoading={
                setStatusMutation.isLoading &&
                setStatusMutation.variables === INJURY_REPORT_STATUS_IDS.REJECTED_MANAGER
              }
              onClick={() => setStatusMutation.mutate(INJURY_REPORT_STATUS_IDS.REJECTED_MANAGER)}
            >
              <Translation id="Reject" />
            </Button>
          </div>
        )}

        <InjuryReport injuryReport={injuryReport} />
      </>
    </Container>
  )
}

export default InjuryReportPage
